import React from "react";
import PropTypes from "prop-types";
import ReactDatePicker, { registerLocale } from "react-datepicker";
import classnames from "classnames";
import enGB from "date-fns/locale/en-GB";
import "./date-picker.scss";
import { format, parseISO } from "date-fns";

registerLocale("en-GB", enGB);

export const formatNativeDate = (date, includesTime = false) => {
  if (!date) {
    return "";
  }

  if (includesTime) {
    return `${format(date, "yyyy-MM-dd")}T${format(date, "HH:mm")}`;
  }

  return format(date, "yyyy-MM-dd");
};

export const parseNativeDate = dateStr => {
  if (!dateStr) {
    return null;
  }
  return parseISO(dateStr);
};

const DatePicker = ({
  id,
  dateFormat,
  date,
  onChange,
  onBlur,
  minDate,
  maxDate,
  includeTime,
  placeholder,
  disabled,
  range,
  isRangeStart,
  isRangeEnd,
  showYearDropdown,
  dropdownYears,
  locale,
  className = "",
  inputRef,
  openToDate,
}) => {
  const handleChangeNative = e => {
    onChange(parseNativeDate(e.target.value));
  };

  const value = formatNativeDate(date, includeTime);
  const min = minDate ? format(minDate, "yyyy-MM-dd") : "";
  const max = maxDate ? format(maxDate, "yyyy-MM-dd") : "";

  const classes = classnames("date-picker-component", className);

  return (
    <div className={classes}>
      <input
        id={id}
        type={includeTime ? "datetime-local" : "date"}
        value={value}
        onChange={handleChangeNative}
        min={min}
        max={max}
        readOnly={disabled}
        className="native-datepicker"
      />
      <ReactDatePicker
        ref={inputRef}
        id={id}
        selected={date}
        minDate={minDate}
        maxDate={maxDate}
        onChange={onChange}
        onBlur={onBlur}
        className="date-picker"
        placeholderText={placeholder}
        readOnly={disabled}
        dateFormat={dateFormat}
        showTimeSelect={includeTime}
        selectsStart={isRangeStart}
        selectsEnd={isRangeEnd}
        startDate={range ? range.startDate : null}
        endDate={range ? range.endDate : null}
        showYearDropdown={showYearDropdown}
        scrollableYearDropdown={showYearDropdown}
        yearDropdownItemNumber={dropdownYears}
        locale={locale}
        openToDate={openToDate}
        autoComplete="off"
      />
    </div>
  );
};

DatePicker.propTypes = {
  inputRef: PropTypes.node,
  id: PropTypes.string.isRequired,
  dateFormat: PropTypes.string.isRequired,
  date: PropTypes.shape({}),
  minDate: PropTypes.shape({}),
  maxDate: PropTypes.shape({}),
  placeholder: PropTypes.string,
  includeTime: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  range: PropTypes.shape({
    startDate: PropTypes.shape({}),
    endDate: PropTypes.shape({}),
  }),
  isRangeStart: PropTypes.bool,
  isRangeEnd: PropTypes.bool,
  showYearDropdown: PropTypes.bool,
  dropdownYears: PropTypes.number,
  locale: PropTypes.string,
  openToDate: PropTypes.shape({}),
};

export default DatePicker;
